<template>
  <div>
    <router-view v-if="isStandalonePage" :key="$route.fullPath"></router-view>
    <MessageDock v-if="isUserStandalonePage" />

    <el-container v-else class="app-shell" :class="{ 'admin-shell': isAdminPage }">
      <el-aside width="auto" v-if="isAdminPage || !isUserStandalonePage">
        <comasideadmin v-if="isAdminPage" />
        <comaside v-else-if="falg3" />
        <comasidepackuer v-else-if="falg2" />
      </el-aside>

      <el-container>
        <el-header v-if="!isAdminPage">
          <comheader />
        </el-header>

        <comtags v-if="!isAdminPage" />
        <el-main>
          <router-view :key="$route.fullPath"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import comaside from '../components/comaside.vue'
import comasideadmin from '../components/comasideadmin.vue'
import comasidepackuer from '../components/comasidepackuer.vue'
import comheader from '../components/comheader.vue'
import comtags from '../components/comtags.vue'
import MessageDock from '../components/MessageDock.vue'

export default {
  components: {
    comaside,
    comheader,
    comtags,
    comasideadmin,
    comasidepackuer,
    MessageDock
  },
  data() {
    return {
      falg3: false,
      falg1: false,
      falg2: false,
      state: ''
    }
  },
  computed: {
    isAdminPage() {
      return this.$route.matched.some(record => record.meta && record.meta.requiresAdmin)
    },
    isUserStandalonePage() {
      return ['home', 'mall', 'user', 'activeOrders', 'dispatchInvitations', 'profile', 'mobilePortal', 'mobileTaskPublish', 'openApiDoc'].includes(this.$route.name)
    },
    isStandalonePage() {
      return this.isUserStandalonePage || ['login', 'adminLogin'].includes(this.$route.name)
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler() {
        this.syncAsideState()
      }
    }
  },
  methods: {
    syncAsideState() {
      this.falg1 = false
      this.falg2 = false
      this.falg3 = false

      if (this.isStandalonePage || this.isAdminPage) {
        return
      }

      this.state = this.$store.state.shudata
      if (this.state === 1) {
        this.falg1 = true
      } else if (this.state === 2) {
        this.falg2 = true
      } else {
        this.falg3 = true
      }
    }
  }
}
</script>

<style scoped>
.el-header {
  padding: 0;
}

.app-shell {
  min-height: 100vh;
}

.admin-shell {
  background:
    radial-gradient(circle at 92% 0%, rgba(143, 241, 199, 0.12), transparent 28%),
    linear-gradient(135deg, #071321 0%, #091524 48%, #050b15 100%);
}

.admin-shell .el-main {
  padding: 0;
}
</style>
